import React, {useContext, useEffect, useRef} from 'react';
import {Route, RouteComponentProps, Switch, useParams} from 'react-router-dom';
import {StoreContext} from '../StoreContext/StoreContext';
import {observer} from 'mobx-react';
import {EChannel} from '../../types/types';
import Layout from '../Layout/Layout';
import Menu from '../Menu/Menu';
import Board from '../Board/Board';
import ChannelSwitcher from '../ChannelSwitcher/ChannelSwitcher';
import NotFoundBoard from '../NotFoundBoard/NotFoundBoard';
import {SEARCH_QUERY_PARAM_TITLE} from "../Search/consts";
import Search from "../Search/Search";
// import {autorun} from 'mobx';

interface IChannelProps extends RouteComponentProps {}

const Channel: React.FC<IChannelProps> = ({history, location}) => {
    let {channelId} = useParams<{channelId: EChannel}>();
    const {routesStore} = useContext(StoreContext);
    // Поисковый запрос.
    const searchQuery = useRef<string | null>(new URLSearchParams(location.search).get(SEARCH_QUERY_PARAM_TITLE));

    const renderMenu = () => {
        const routes = routesStore.routes[channelId];
        if (routes) {
            return (
                <>
                    <div className="mobile-search">
                        <Search />
                    </div>

                    {/* <ChannelSwitcher channelTitle={channelId} />
*/}
                    <Menu location={location} menu={routes.routes} />
                </>
            );
        }
    };

    // Обработчик изменения url. Удаляет query параметр 'query'. Он устанавливается при переходе на страницу из поиска. При переходе на следующую страницу - удаляется.
    const handleChangeLocation = (location: any) => {
        const queryParams = new URLSearchParams(location.search);
        const queryParam = queryParams.get(SEARCH_QUERY_PARAM_TITLE);

        // Существует предыдущее значение равное новому значению.
        if (searchQuery.current && queryParam === searchQuery.current) {
            // Удаление параметра.
            queryParams.delete(SEARCH_QUERY_PARAM_TITLE);
            history.replace({...location, search: queryParams.toString()})
        } else {
            searchQuery.current = queryParam;
        }
    }

    useEffect(() => {
        return history.listen(handleChangeLocation);
    }, []);

    // Без карты роутов отрисовать Board нельзя.
    if (!Object.keys(routesStore.routesAndBoardsMap).length) {
        return null;
    }

    return (
        <Layout menu={renderMenu()}>
            <Switch>
                {Object.keys(routesStore.routesAndBoardsMap).map((route) => {
                    return (
                        <Route
                            // Добавлено для заглавных страниц раздела.
                            exact
                            key={route}
                            path={route}
                            render={(routeProps) => <Board {...routeProps} id={routesStore.routesAndBoardsMap[route].id} />}
                        />
                    );
                })}
                <Route path="*" component={NotFoundBoard} />
            </Switch>
        </Layout>
    );
};

export default observer(Channel);
